//
//  Determine which dialog is appropriate when a user presses the Home button on the Serve screen.
//
//  MEAL_COUNTER    Meal Counter session with unprocessed meals
//
//  INCOMPLETE      There are bought items (in the cart)
//                  There is a Paid Amount
//                  A Teacher is serving with Students Selected
//
//  DEFAULT         All other conditions
//

export const DIALOG_TYPES = {
  CONFIRM: 0,
  MEAL_COUNTER: 1,
  INCOMPLETE: 2,
};

export const getHomeButtonDialogType = currentprops => {
  const {
    isCurrentSessionMealCounter,
    hasUnprocessedMeals,
    hasBoughtItems,
    hasPaidAmount,
    hasTeacherStudentsSelected,
  } = currentprops;

  if (hasBoughtItems || hasPaidAmount || hasTeacherStudentsSelected) {
    return DIALOG_TYPES.INCOMPLETE;
  } else if (isCurrentSessionMealCounter && hasUnprocessedMeals) {
    return DIALOG_TYPES.MEAL_COUNTER;
  } else {
    return DIALOG_TYPES.CONFIRM;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/helpers/homeButtonHelper.js